import imageSeoData from "../data/image-seo-data.json";

export interface ImageSeoData {
  title: string;
  alt: string;
}

class ImageAltGenerator {
  private data: ImageSeoData[] = imageSeoData;

  public getRandomImageSeo(username?: string, name?: string, variation?: string | number): ImageSeoData {
    if (!this.data || this.data.length === 0) {
      return {
        title: "",
        alt: "",
      };
    }

    const randomIndex = this.getConsistentRandomIndex(username, variation);
    const selectedSeo = this.data[randomIndex];

    return this.replacePlaceholders(selectedSeo, name);
  }

  private replacePlaceholders(seo: ImageSeoData, name?: string): ImageSeoData {
    const creatorName = name || "Créateur";

    let title = seo.title;
    let alt = seo.alt;

    title = title.replace(/nomduprofil/g, creatorName);
    title = title.replace(/nomprofil/g, creatorName);

    alt = alt.replace(/nomduprofil/g, creatorName);
    alt = alt.replace(/nomprofil/g, creatorName);

    return {
      title,
      alt,
    };
  }

  private getConsistentRandomIndex(username?: string, variation?: string | number): number {
    if (!username) {
      return Math.floor(Math.random() * this.data.length);
    }

    const seed = variation !== undefined ? `${username}_${variation}` : username;

    let hash = 0;
    for (let i = 0; i < seed.length; i++) {
      const char = seed.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash;
    }

    return Math.abs(hash) % this.data.length;
  }

  public getTotalCount(): number {
    return this.data.length;
  }
}

export const imageAltGenerator = new ImageAltGenerator();

/**
 * Legacy function for backward compatibility
 * Now uses the new imageAltGenerator system
 */
interface GenerateAltTextParams {
  name?: string;
  username?: string;
  index?: number;
  id?: string;
  fallback?: string;
  isVideo?: boolean;
}

export const generateImageAltText = ({ name, username, fallback = "image" }: GenerateAltTextParams): string => {
  if (!name && !username) {
    return fallback;
  }

  const seoData = imageAltGenerator.getRandomImageSeo(username, name);
  return seoData.alt || fallback;
};

/**
 * Get both title and alt attributes for an image
 * @param username - Creator username
 * @param name - Creator name
 * @param variation - Optional variation parameter (index, id, or type) to generate different alt/title for same creator
 */
export const generateImageSeoAttributes = (username?: string, name?: string, variation?: string | number): ImageSeoData => {
  return imageAltGenerator.getRandomImageSeo(username, name, variation);
};
